__webpack_require__.p = "/energy/paper/Land_Use_Dynamics_Karnataka/";